import axios from 'axios'
import constants from '../constants'

const ILLUSTRATION_PATH = constants.urlPrefix + '/api/illustration'

const updateIllustration = (dto) => axios.put(ILLUSTRATION_PATH, dto)

const findTags = function (name) {
    return axios.get(ILLUSTRATION_PATH + '/tags', {
        params: { name }
    })
}

const createTag = function (tag) {
    return axios.post(ILLUSTRATION_PATH + '/tags', tag)
}


const findFolders = function (name) {
    return axios.get(ILLUSTRATION_PATH + '/folders', {
        params: { name }
    })
}

const createFolder = function (folder) {
    return axios.post(ILLUSTRATION_PATH + '/folders', folder)
}

export default {
    updateIllustration,
    findTags,
    createTag,
    findFolders,
    createFolder,
}